// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"584f3c9a","219":"cbe13b77","579":"654fe192"}[chunkId] + ".chunk.css";
};